import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c83d0c1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["src"]

import iconCorrectCircle from '@/assets/svg/correct-circle.svg'
import iconWrongCircle from '@/assets/svg/wrong-circle.svg'
import iconSelectedCircle from '@/assets/svg/selected-circle.svg'
import iconEmptyCircle from '@/assets/svg/empty-circle.svg'


export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    selected: { type: Boolean },
    correct: { type: Boolean },
    wrong: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  text: string
  selected?: boolean
  correct?: boolean
  wrong?: boolean
}



function getButtonIcon() {
  if (props.correct) {
    return iconCorrectCircle
  } else if (props.wrong) {
    return iconWrongCircle
  } else if (props.selected) {
    return iconSelectedCircle
  } else {
    return iconEmptyCircle
  }
}

function getButtonStyle() {
  if (props.correct) {
    return 'btn-choices-correct'
  } else if (props.wrong) {
    return 'btn-choices-wrong'
  } else if (props.selected) {
    return 'btn-choices-selected'
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["btn btn-md btn-choices", getButtonStyle()])
  }, [
    _createElementVNode("p", {
      class: "text-md",
      innerHTML: props.text
    }, null, 8, _hoisted_1),
    _createElementVNode("img", {
      src: getButtonIcon()
    }, null, 8, _hoisted_2)
  ], 2))
}
}

})